module.exports = __webpack_public_path__ + "static/media/indentplanner2.9a91170d.png";